exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blank-cell[data-v-05593297]{font-style:italic;color:#cccccc}.blank-cell span.invisible-content[data-v-05593297]{opacity:0}\n", ""]);

// exports
